module.exports = __webpack_public_path__ + "static/media/logoDrDiabetes.6bf44dfd.png";